import { FC, ReactNode } from 'react';
import { AuthProvider } from '@/contexts/auth/AuthProvider';
import { SidebarProvider } from '@/contexts/sidebar/SidebarProvider';
import { ToastNotificationProvider } from '@/contexts/toastNotification/ToastNotificationProvider';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

type AppProviderProps = {
  children: ReactNode;
};

export const queryClient = new QueryClient();

const reCaptchaKey = process.env['REACT_APP_RECAPTCHA_PUBLIC_KEY'] ?? '';

const AppProvider: FC<AppProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <GoogleReCaptchaProvider reCaptchaKey={reCaptchaKey}>
        <ToastNotificationProvider>
          <SidebarProvider>
            <AuthProvider>{children}</AuthProvider>
          </SidebarProvider>
        </ToastNotificationProvider>
      </GoogleReCaptchaProvider>
    </QueryClientProvider>
  );
};

export default AppProvider;
